/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `packaging` - % of packaging
* `food` - % of food
* `purchased_goods` - % of purchased goods
* `total_weight` - Total weight
 */
export type WeightOptionEnum = typeof WeightOptionEnum[keyof typeof WeightOptionEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WeightOptionEnum = {
  packaging: 'packaging',
  food: 'food',
  purchased_goods: 'purchased_goods',
  total_weight: 'total_weight',
} as const;
